<template>
  <b-row>
    <b-col cols="12">
      <user-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import UserContent from './UserContent.vue'

export default {
  components: {
    BRow,
    BCol,

    UserContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>